// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import ICU from "i18next-icu";
import { getTranslationsPath, getTranslationsCommonPath } from "./utils/pathConfig";

const fallbackLng = "en";

// Get locale from window.__OPTIONS__ if available, otherwise let LanguageDetector handle it
const initialLanguage = window.__OPTIONS__?.locale || undefined;

i18n
  .use(ICU)
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: initialLanguage, // Set initial language from window.__OPTIONS__.locale
    fallbackLng,
    debug: false,
    // Load both common and game namespaces - both always available
    ns: ["common", "game"],
    defaultNS: "game", // game namespace is default (translations.json)
    fallbackNS: ["common", "game"], // Always search in both namespaces

    // Disable language detection when locale is explicitly provided
    detection: {
      order: [], // Disable all detection methods when we have explicit locale
    },

    // Don't normalize language codes - keep en-SOCIAL as is
    load: 'currentOnly', // Only load the exact language, don't try en-US -> en fallback

    interpolation: {
      escapeValue: false,
    },
    backend: {
      // Load translations from different folders based on namespace
      loadPath: (lngs, namespaces) => {
        let lng = lngs[0]; // Get the language code

        // Fix for en-SOCIAL: i18next lowercases it to en-social, restore original case
        if (lng === 'en-social') {
          lng = 'en-SOCIAL';
        }

        if (namespaces[0] === "common") {
          // Use centralized path configuration
          return getTranslationsCommonPath(lng, fallbackLng);
        }
        // game namespace
        return getTranslationsPath(lng, fallbackLng);
      },
      requestOptions: {
        cache: "default",
      },
    },
    // Performance optimizations
    react: {
      useSuspense: false, // Disable suspense for better performance
      bindI18n: "languageChanged loaded", // Only bind to essential events
      bindI18nStore: "added removed", // Only bind to essential store events
      transEmptyNodeValue: "", // Default empty value
      transSupportBasicHtmlNodes: false, // Disable HTML node support for performance
      transWrapTextNodes: "", // Don't wrap text nodes
    },
    // Cache translations to avoid repeated HTTP requests
    initImmediate: false, // Don't initialize immediately
  });

export default i18n;
